import { jobArchitectureSchema } from './job-architecture';

import type { JobArchitecture } from './job-architecture';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type Result from 'true-myth/result';

export type CreateNewJobArchitecture = () => Promise<Result<JobArchitecture, Error>>;

export const createCreateNewJobArchitecture = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): CreateNewJobArchitecture => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return () => {
        return validatingCobrainerApiFetcher.postJson(jobArchitectureSchema, {
            pathname: `/job-architectures`,
            payload: {
                translations: [],
            },
        });
    };
};
